<template>
  <div></div>
</template>
    
<script>
export default {
  name: "ListCouponsView",
  components: {},
};
</script>